
const userToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoib2xkLW1vcm5pbmctNCJ9.ZwX0bpmkwUVqXWtcP3qizjEAldcjumOQ07cM7WFq-5o';


const users = [
    {
        id: 'old-morning-4',
        name: 'Steve Miller',
        image: 'https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=150&q=80',
        userToken: userToken,
    },
    {
        id: 'jethro-tull',
        userToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiamV0aHJvLXR1bGwifQ.7uuwepRobpYXbPaaFpQp9ALS9zUjpklZB90xdsLmuZU',
        name: 'Jethro Tull',
        image: 'https://images.unsplash.com/photo-1554727242-741c14fa561c?ixlib=rb-1.2.1&auto=format&fit=crop&w=150&q=80'
    },
    {
        id: 'jimi-hendrix',
        userToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiamltaS1oZW5kcml4In0.3f4bJOu4wvSiNoWV9NV-Xn40Gn1TRacrHfLScU1boa8',
        name: 'Jimi Hendrix',
        image: 'https://images.unsplash.com/photo-1525201548942-d8732f6617a0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=150&q=80'
    },
    {
        id: 'kat-holders',
        userToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoia2F0LWhvbGRlcnMifQ.AcAC6qN1P37c2uOEpvqN98TWfrRIqL8if5O1Bp7ZbQE',
        name: 'Katrina Hendrix',
        image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=150&q=80'
    }
];



export default users;